import React from 'react';

import { Button, Col, Modal, Row } from 'react-bootstrap';

export const ConfirmModal = ({
  title,
  message,
  onConfirm,
  onHide,
  show,
  loading,
  error,
}) => {
  return (
    <Modal show={show.show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 400 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        {error ? <p className="text-danger">{error.message}</p> : null}
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col sm={6}>
            <Button block disabled={loading} onClick={onHide}>
              Cancel
            </Button>
          </Col>

          <Col sm={6}>
            <Button
              block
              bsStyle="primary"
              disabled={loading}
              onClick={() => onConfirm(show.id)}
            >
              {loading ? 'Sending' : 'Confirm'}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};
